import { apiRequest } from "./apiClient";

export const getCertifications = async (section) => {
  const query = section ? `?section=${encodeURIComponent(section)}` : "";
  const data = await apiRequest(`/certifications${query}`);
  return data.certifications || [];
};